export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteDialog.json?hash=8979c3c4536fbbed4e9ce81ff805f1b0";